import { render, staticRenderFns } from "./outputRecord.vue?vue&type=template&id=cd878754&scoped=true"
import script from "./outputRecord.vue?vue&type=script&lang=js"
export * from "./outputRecord.vue?vue&type=script&lang=js"
import style0 from "./outputRecord.vue?vue&type=style&index=0&id=cd878754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd878754",
  null
  
)

export default component.exports